module.exports = __webpack_public_path__ + "img/vonestis_spa_02.0ed2c0d0.jpg";